import { PlanMainService } from './../../../plan/service/plan-main.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NewsService } from '../../../services/news.service';
import { Subject } from 'rxjs/Subject';
import { UtilService } from '../../../services/util.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-information',
  templateUrl: './new-information.component.html',
  styleUrls: ['./new-information.component.css']
})
export class NewInformationComponent implements OnInit {
  @Output() close: EventEmitter<any> = new EventEmitter();
  editnews = false;
  public date0: Date;
  public newsTitle: string = '';
  public newsDetail: string = '';
  public newsEnabled: number;
  private ngUnsubscribe = new Subject();
  currentDate: any;
  public newsList: any;
  public newsPage: number = 1;
  public totalPages: number = 0;
  public countNews: number = 0;
  public isUpdate: boolean = false;
  public idUpdate: number;
  public displayError: boolean = false;
  public inputName: string = '';
  public inputFocus: string = '';
  constructor(
    private _planmainService: PlanMainService,
    private newsService: NewsService,
    private _util: UtilService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getNewsList();
  }

  getDateValue(event: any) {
    if (event && event.format) {
      this.currentDate = this._planmainService.setStringdate(
        'YYYYMMDD',
        event.value
      );
    } else {
      this.currentDate = null;
    }
  }

  getNewsList() {
    this.newsService
      .getNewsListAdmin(this.newsPage, 10, '-date,-id')
      .takeUntil(this.ngUnsubscribe)
      .subscribe(data => {
        if (data) {
          data.results.map(res => {
            res.bodyFull = res.body;
            res.body = res.body.replace(/\\n/g, " ");
            const titleLength = this._util.getUTF8Length(res.body, 100);
            if (titleLength.count > 100) {
              res.body = res.body.substr(0, titleLength.strCount) + "...";
            } else {
              res.body = res.body;
            }
          });
          this.newsList = data.results;
          this.totalPages = data.totalPages;
          this.countNews = data.results.length;
        } else {
          this.newsList = [];
          this.totalPages = 0;
          this.countNews = 0;
        }
      });
  }

  addNews() {
    if (this.currentDate && this.newsTitle && this.newsDetail) {
      const data = {
        date: this.currentDate,
        title: this.newsTitle,
        body: this.newsDetail,
        enabled: this.newsEnabled
      };

      this.newsService
        .addNews(data)
        .takeUntil(this.ngUnsubscribe)
        .subscribe(isSuccess => {
          this.editnews = false;
          this.newsEnabled = null;
          this.getNewsList();
        },
          err => {
            if (err.status) {
              alert(err.message);
            } else {
              if (Number(err.rsltCode.substr(1, 4)) >= 500) {
                alert('システムエラーが発生しました。');
              } else if (Number(err.rsltCode.substr(1, 4)) >= 400) {
                alert(err.rsltComment);
              }
            }
          });
    } else {
      this.validInput();
    }
  }

  updateNews() {
    if (this.currentDate && this.newsTitle && this.newsDetail) {
      const data = {
        id: this.idUpdate,
        date: this.currentDate,
        title: this.newsTitle,
        body: this.newsDetail,
        enabled: this.newsEnabled
      };

      this.newsService
        .updateNews(data)
        .takeUntil(this.ngUnsubscribe)
        .subscribe(isSuccess => {
          this.editnews = false;
          this.newsEnabled = null;
          this.getNewsList();
        },
          err => {
            if (err.status) {
              alert(err.message);
            } else {
              if (Number(err.rsltCode.substr(1, 4)) >= 500) {
                alert('システムエラーが発生しました。');
              } else if (Number(err.rsltCode.substr(1, 4)) >= 400) {
                alert(err.rsltComment);
              }
            }
          });
    } else {
      this.validInput();
    }
  }

  validInput() {
    if (!this.currentDate) {
      this.inputName = '日付';
      this.inputFocus = 'date';
    } else if (!this.newsTitle) {
      this.inputName = '題名';
      this.inputFocus = 'title';
    } else if (!this.newsDetail) {
      this.inputName = '本文';
      this.inputFocus = 'body';
    }
    this.displayError = true;
  }

  isShowNews(val: number) {
    this.newsEnabled = val;
  }

  onClose() {
    if (this.router.url == '/home') {
      this.newsService.isReload.next(true);
    }
    this.close.emit(false);
  }

  onEditNews(e: boolean) {
    this.editnews = e;
    if (e == false) {
      this.newsEnabled = null;
    } else {
      this.newsEnabled = 1;
      this.isUpdate = false;
      this.newsTitle = '';
      this.newsDetail = '';
      this.date0 = null;
    }
  }

  editNewsItems(data: any) {
    this.editnews = true;
    this.isUpdate = true;
    this.newsTitle = data.title;
    this.newsDetail = data.bodyFull;
    this.newsEnabled = data.enabled;
    this.idUpdate = data.id;
    this.date0 = this._planmainService.getDate(data.date, 'YYYYMMDD');
  }

  prevPage() {
    if (this.newsPage > 1) {
      this.newsPage -= 1;
      this.getNewsList();
    }
  }

  nextPage() {
    if (this.newsPage < this.totalPages) {
      this.newsPage += 1;
      this.getNewsList();
    }
  }

  oncloseDialog() {
    this.displayError = false;
    (<HTMLElement>document.getElementById(this.inputFocus)).focus();
  }

  enterKey(e, id: string) {
    (<HTMLElement>document.getElementById(id)).focus();
    e.preventDefault();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/new-information/new-information.component.ts